import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailAboutProps as Props } from './types';
import type { CompanyProfileDetail } from '../../../types/companyDetail';
import { getCompanyProfileDetails } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [details, setDetails] = useState<CompanyProfileDetail>({
    name: '',
    shihonkin: '',
    setsuritsunengetsu: '',
    daihyoshaname: '',
    jugyoinsu: '',
    honshashozaichi: '',
    industries: [],
    url: '',
  });

  useEffect(() => {
    let aborted = false;

    const fetchProfileDetails = async () => {
      try {
        const response = await getCompanyProfileDetails(props.company.id);
        if (aborted) return;
        setDetails({
          name: response.name ?? '',
          shihonkin: response.shihonkin ?? '',
          setsuritsunengetsu: response.setsuritsunengetsu ?? '',
          daihyoshaname: response.daihyoshaname ?? '',
          jugyoinsu: response.jugyoinsu ?? '',
          honshashozaichi: response.honshashozaichi ?? '',
          industries: Array.isArray(response.industries) ? response.industries : [],
          url: response.url ?? '',
        });
      } catch (error) {
        console.log(error);
      }
    };

    fetchProfileDetails();
    return () => { aborted = true; };
  }, [props.company.id]);

  return (
    <Presentation
      details={details}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
    />
  );
};
